import React, { useEffect, useState } from 'react';
import '../../shop/styles/purchaseModal.css';
import './AutoCollectModal.css';
import ModalBackground from '../../../shared/components/ModalBackground';
import PurchaseActions from '../../../shared/components/PurchaseActions';
import { useTranslation } from 'react-i18next';
import { entityText } from '../../../i18n/entityText';

export default function AutoCollectModal({ onClose, item, items }) {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);
  const [index, setIndex] = useState(0);

  // Support both `items` array and single `item` prop
  const list = items && items.length > 0 ? items : (item ? [item] : []);
  const current = list[index] || null;

  useEffect(() => { setVisible(true); }, []);

  const handleClose = () => {
    setVisible(false);
    setTimeout(onClose, 300);
  };

  const goLeft  = (e) => { e.stopPropagation(); setIndex(i => (i - 1 + list.length) % list.length); };
  const goRight = (e) => { e.stopPropagation(); setIndex(i => (i + 1) % list.length); };

  const usdPrice    = current?.usdt          ? parseFloat(current.usdt)          : null;
  const originalUsd = current?.originalPrice ? parseFloat(current.originalPrice) : null;
  const hasDiscount = originalUsd !== null && usdPrice !== null && originalUsd > usdPrice;
  const duration    = current?.durationDays  ?? (index === 0 ? 7 : 30);
  const hasItem     = !!current?.id;

  return (
    <div className="purchase-modal-overlay" onClick={handleClose}>
      <div
        className={`purchase-modal-sheet autocollect-sheet ${visible ? 'visible' : ''}`}
        onClick={e => e.stopPropagation()}
      >
        <ModalBackground />

        {/* Header */}
        <div className="purchase-modal-header" style={{ position: 'relative', overflow: 'visible' }}>
          <h2 className="purchase-modal-title" style={{ position: 'relative', zIndex: 1 }}>
            {t('autocollect.title', 'Tickets auto collect')}
          </h2>
          <img
            className="purchase-modal-close"
            src="/close.png"
            alt="close"
            onClick={handleClose}
            style={{ position: 'absolute', zIndex: 1 }}
          />
        </div>

        <div style={{ height: 2, background: '#5f5c7c' }} />

        {/* Body */}
        <div className="autocollect-body">
          {/* Price section with nav arrows */}
          <div className="autocollect-price-row">
            {list.length > 1 && (
              <button className="autocollect-arrow autocollect-arrow--left" onClick={goLeft}>‹</button>
            )}

            <div className="autocollect-price-center">
              {hasDiscount && (
                <p className="purchase-modal-old-price" style={{ fontSize: 28 }}>
                  {originalUsd.toFixed(2)} USD
                </p>
              )}
              <p className="autocollect-new-price">
                {usdPrice !== null ? `${usdPrice.toFixed(2)} USD` : '—'}
              </p>
              <div className="autocollect-duration-badge">
                <span>{t('autocollect.price_for_days', 'Price for {{n}} days', { n: duration })}</span>
              </div>
              {hasDiscount && (
                <p className="autocollect-discount-label">{t('autocollect.first_discount', 'First Purchase Discount')}</p>
              )}
            </div>

            {list.length > 1 && (
              <button className="autocollect-arrow autocollect-arrow--right" onClick={goRight}>›</button>
            )}
          </div>

          {/* Dots indicator */}
          {list.length > 1 && (
            <div className="autocollect-dots">
              {list.map((_, i) => (
                <span key={i} className={`autocollect-dot ${i === index ? 'active' : ''}`} />
              ))}
            </div>
          )}

          {/* Description */}
          <p className="purchase-modal-desc" style={{ marginTop: 16, marginBottom: 20 }}>
            {current?.description
              ? entityText(t, 'shop_item', current.id, 'description', current.description)
              : t('autocollect.description', 'Buy the Tickets Auto Collector and forget about timers! Auto collect tickets automatically collects your free tickets every 8 hours so you never miss a spin!')}
          </p>

          <PurchaseActions
            allowTON={true}
            allowStars={true}
            purchaseType="AUTO_COLLECT"
            itemId={current?.id}
            usdPrice={current?.usdt}
            priceTON={current?.priceTON}
            priceStars={current?.priceStars}
            description={current?.name
              ? entityText(t, 'shop_item', current.id, 'name', current.name)
              : t('autocollect.title', 'Tickets auto collect')}
            disabled={!hasItem}
            onClose={handleClose}
          />
        </div>
      </div>
    </div>
  );
}
